import Vue from 'vue';

/**
 * Global Definitions
 */
 import Dem from './components/index';

 /**
  * Global Definitions
  * Local Components Which we have control off.
  */

 /** --------- */
 Vue.component("icon",                Dem.Icons.FontAwesomeIcon);

  /** Elements --------- */
  Vue.component("pageHeader", Dem.Elements.pageHeader);
  Vue.component("detailsHeader", Dem.Elements.detailsHeader);
  Vue.component("backButton", Dem.Elements.backButton);

 /** Layout --------- */
 Vue.component("intro", Dem.Layouts.intro);
 Vue.component("Home", Dem.Layouts.Home);
 Vue.component("mainLanding", Dem.Layouts.mainLanding);
 Vue.component("questionSet", Dem.Layouts.questionSet);
 Vue.component("share", Dem.Layouts.share);
 Vue.component("shareForm", Dem.Layouts.shareForm); 
 Vue.component("loading", Dem.Layouts.loading);


 export default {};